<template>
    <v-dialog v-model="affiche" persistent max-width="500">
      <v-card class="mx-auto">
        <v-card-title class="headline primary white--text d-flex justify-space-between">
          <span>
            Information
          </span>
          <span>
            <v-btn color="white" icon @click="$emit('close')">
              <v-icon medium>mdi-close-circle</v-icon>
            </v-btn>
          </span>
        </v-card-title>
        <v-card-text class="body-1 black--text pt-3">
          <span v-html="texte" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="fixedBoutton" v-if="!isLara && isRedirectXtranet" color="primary" :href="url_extranet">Se connecter</v-btn>
          <v-btn class="fixedBoutton" v-if="isLara && !isRedirectXtranet" color="primary" :href="url_extranet_lara">Se connecter</v-btn>
          <v-btn class="fixedBoutton" v-if="isLara" color="primary" to="../demande-admission-public">Poursuivre</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {getExtranetUrl} from "@/utils/stringUtils"

  export default {
    props: {
      affiche: Boolean,
      isConnexionLara: Boolean,
      isRedirectXtranet: Boolean,
      texte: String,
    },
    data: function () {
      return {
        url_extranet: getExtranetUrl(process.env.VUE_APP_HOME_XTRANET),
        url_extranet_lara: getExtranetUrl(process.env.VUE_APP_CONNEXION_EXTERNE_XTRANET)
      }
    },
    computed: {
      isLara () {
        return this.isConnexionLara;
      }
    }
  }
</script>
<style scoped>
.fixedBoutton{
    width: 135px;
}
</style>